import { mapToConvoAIProductName } from './prompt-requests/utils/get-convoai-supported-product-name';

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
type XProductHeader = { 'X-Product': string } | {};
/**
 * Only send the X-Product header if the request is to the assistance-service
 * Exported for testing purposes
 */
export const getXProductHeader = (product: string): XProductHeader => {
	return {
		'X-Product': mapToConvoAIProductName(product),
	};
};
